var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/share"},[React.createElement("path",{"id":"Vector 25","d":"M12 14V2M12 2L15 5M12 2L9 5","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector 26","d":"M8.5 8H7.5C6.39543 8 5.5 8.89543 5.5 10V20.0002C5.5 21.1047 6.39543 22.0002 7.5 22.0002H16.5C17.6046 22.0002 18.5 21.1047 18.5 20.0002V10C18.5 8.89543 17.6047 8 16.5001 8C16.1688 8 15.8268 8 15.5 8","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Share.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Share;

Share.default = Share;
